const legacyGlobalThis = {};
/**
 * 获取 globalThis 对象
 * @returns
 */
export const getGlobalThis = () => (typeof globalThis !== 'undefined'
    ? globalThis
    : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ legacyGlobalThis);
